import React from 'react'
import PropTypes from 'prop-types'

import { Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material'
import { EyeOff } from '@styled-icons/heroicons-outline/EyeOff'
import { Eye } from '@styled-icons/heroicons-outline/Eye'

const ActionMenu = ({ anchorEl, withDeactivated = false, onToggleStatus, onClose }) => (
  <Menu
    slotProps={{ paper: { variant: 'outlined', sx: { minWidth: 250 } } }}
    anchorEl={anchorEl}
    open={Boolean(anchorEl)}
    onClose={onClose}
    disableScrollLock
    keepMounted
  >
    <MenuItem onClick={onToggleStatus}>
      <ListItemIcon sx={{ mr: 1 }}>{withDeactivated ? <EyeOff width={24} height={24} /> : <Eye width={24} height={24} />}</ListItemIcon>
      <ListItemText>{withDeactivated ? 'Hide deactivated' : 'Show deactivated'}</ListItemText>
    </MenuItem>
  </Menu>
)

ActionMenu.propTypes = {
  anchorEl: PropTypes.object,
  withDeactivated: PropTypes.bool,
  onToggleStatus: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default ActionMenu
